module.exports = "<p>\n  test9 works!\n</p>\n"